import { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Rings } from '@/components/composite/Rings'
import {
  rewardCardVariants,
  rewardCardLabelVariants,
  rewardCardIconVariants
} from './RewardCard.variants'

export interface RewardCardProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  reward: string
  icon: React.ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue'
}

export const RewardCard = forwardRef<HTMLDivElement, RewardCardProps>(
  ({ label, reward, icon, accentColor = 'none', className, ...props }, ref) => {
    return (
      <div className={rewardCardVariants({ accentColor, className })} ref={ref} {...props}>
        <div
          className={twMerge(
            'relative flex items-center justify-center',
            'h-[55px]',
            'text-lg font-bold'
          )}
        >
          <span className="relative z-10 [text-shadow:0px_2px_2px_rgba(0,0,0,0.25)]">{reward}</span>
          <div className={rewardCardIconVariants({ accentColor })}>{icon}</div>
          <Rings accentColor={accentColor} className="scale-[0.55]" variant="gradient" />
        </div>
        <div className={rewardCardLabelVariants({ accentColor })}>{label}</div>
      </div>
    )
  }
)

RewardCard.displayName = 'RewardCard'
